import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import pay from './pay'
import bindCard from './bindCard'
import findPwd from './findPwd'
import cardManage from './cardManage'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    redirect: 'PayCardList',
  },
  {
    path: '/payCardList',
    name: 'PayCardList',
    component: () => import('@/views/payCardList.vue'),
  },
  ...pay,
  ...bindCard,
  ...findPwd,
  ...cardManage,
  {
    path: '/payManage',
    name: 'PayManage',
    component: () => import('@/views/payManage.vue'),
  },
  {
    path: '/paySet',
    name: 'PaySet',
    component: () => import('@/views/paySet.vue'),
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import('@/views/disclaimer.vue'),
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
